import React from "react";
import { Link } from "react-router-dom";

const ProjectCard = ({project}) => {
    const {_id, image, description, project_name, url} = project
  return (
    <div className="card border-2 border-black">
      <figure className="rounded-xl">
        <img  src={image} alt="Shoes" />
      </figure>
      <div className="card-body">
        <h2 className="card-title">{project_name}</h2>
        <p>{description}</p>
        <div className="card-actions justify-end">
          <Link to={`/projects/${_id}`} className="btn border-2 bg-neon text-black hover:text-white">See more</Link>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
